// import { Commit } from 'vuex'
import store from '@/store'
import { Action, getModule, Module, Mutation } from 'vuex-module-decorators'
import ErrorCorrection from './modules/error-correction'

interface State {
  course: object
  imagePreviewList: Array<any>
}

// interface GetCourseParams {
//   courseId: string;
//   trainClassId: string;
//   extParams: string;
// }
@Module({
  namespaced: true,
  name: 'Exam',
  store,
  dynamic: true
})
class Exam extends ErrorCorrection implements State {
  course: object = new Object()
  imagePreviewList = new Array<any>()
  @Action
  setPreviewImageList(payload: any) {
    this.SET_PREVIEW_IMAGE_LIST(payload)
  }
  @Mutation
  SET_PREVIEW_IMAGE_LIST(payload: any) {
    this.imagePreviewList = payload
  }
  // return {
  //   namespaced: true,
  //   state: new State(),
  //   actions: {
  //     setPreviewImageList(ctx: { commit: Commit }, payload: any) {
  //       ctx.commit('SET_PREVIEW_IMAGE_LIST', payload)
  //     }
  //   },
  //   mutations: {
  //     SET_PREVIEW_IMAGE_LIST(state: State, payload: any) {
  //       state.imagePreviewList = payload
  //     }
  //   },
  //   modules: {
  //     errorCorrection: new ErrorCorrection()
  //   }
  // }
}
export default getModule(Exam)
